/**
 * Navegação do módulo Cadastros.
 * Itens com `permission` / `anyPermission` só aparecem se o usuário tiver acesso.
 */

import {
  ANY_PRODUTOS_ACCESS,
  ANY_WORKFLOW,
  PERM_ESTOQUE,
  PERM_SOLICITAR,
} from "../shared/permissions";

export const DRAWER_WIDTH = 280;
export const DRAWER_WIDTH_COLLAPSED = 72;

export const NAV_ITEMS = [
  {
    path: "/modulo/cadastros/produtos/consulta",
    label: "Localizar Produtos",
    shortLabel: "Localizar",
    icon: "Search",
    anyPermission: ANY_PRODUTOS_ACCESS,
  },
  {
    path: "/modulo/cadastros/dashboard",
    label: "Dashboard",
    shortLabel: "Dashboard",
    icon: "Dashboard",
    anyPermission: ANY_WORKFLOW,
  },
  {
    path: "/modulo/cadastros/produtos",
    label: "Solicitações",
    shortLabel: "Solicitações",
    icon: "Inventory",
    anyPermission: ANY_WORKFLOW,
  },
  {
    path: "/modulo/cadastros/produtos/nova",
    label: "Nova solicitação",
    shortLabel: "Nova",
    icon: "Add",
    permission: PERM_SOLICITAR,
  },
  {
    path: "/modulo/cadastros/produtos/estoque",
    label: "Aguardando Estoque",
    shortLabel: "Estoque",
    icon: "Warehouse",
    permission: PERM_ESTOQUE,
  },
  {
    path: "/modulo/cadastros/produtos/master",
    label: "Aguardando Master",
    shortLabel: "Master",
    icon: "Account",
    permission: PERM_SOLICITAR,
  },
  {
    path: "/modulo/cadastros/produtos/cadastro",
    label: "Fila de cadastro",
    shortLabel: "Cadastro",
    icon: "Check",
    permission: PERM_SOLICITAR,
  },
];

/** @deprecated Use NAV_ITEMS — mantido para compatibilidade. */
export const NAV_GROUPS = [{ id: "menu", label: "Menu", items: NAV_ITEMS }];

export const getNavItemByPath = (pathname) => {
  const normalized = pathname.replace(/\/$/, "") || "/";
  return (
    [...NAV_ITEMS]
      .sort((a, b) => b.path.length - a.path.length)
      .find(
        (item) =>
          normalized === item.path || normalized.startsWith(`${item.path}/`)
      ) || null
  );
};
